export default {
  translation: {
    navigation: {
      products: 'Продукты',
      whereToBuy: 'Где купить',
    },
    hero: {
      title: 'Создаем моменты вокруг вашего стола',
      description: 'Ищете стильный и практичный стол для всей семьи и гостей? Или, может быть, вы хотите найти минималистичный вариант для небольшой кухни? Тогда вы попали по адресу: в нашем ассортименте есть практичные, современные, скандинавские, индустриальные и классические варианты, и вы легко найдете тот, который лучше всего подойдет к декору вашего дома или даже станет его центральным элементом.',
      exploreButton: 'Изучить коллекцию',
    },
    products: {
      title: 'Наша коллекция',
      description: 'Коллекция состоит из столов, изготовленных из качественных материалов, таких как ДСП (МДФ; МДП), массив дерева, металл, стекло, пластик, мрамор и другие материалы, которые гарантируют, что вы будете наслаждаться своей мебелью долгие годы. Так что не ждите и начинайте искать свой самый важный предмет обеденной мебели!',
      inStock: 'В наличии',
      preOrder: 'Предзаказ',
      viewDetails: 'Подробнее',
      currency: '€',
    },
    cta: {
      title: 'Где купить',
      description: 'Наши столы доступны через партнерский магазин.',
      chat: {
        title: 'Чат с нами',
        description: 'Получите мгновенные ответы о наших продуктах, ценах и наличии.',
        button: 'Начать чат',
      },
      buy: {
        title: 'Купить у партнеров',
        description: 'Посетите наш партнерский магазин, чтобы купить товары и оценить качество лично.',
        button: 'Купить',
      },
    },
    footer: {
      description: 'Каждое изделие рассказывает историю мастерства и преданности делу.',
      contact: 'Свяжитесь с нами',
      rights: 'Все права защищены.',
      poweredBy: 'разработано',
    },
    product: {
      backToCollection: 'Назад к коллекции',
      colors: 'Доступные цвета',
      features: 'Характеристики',
      specifications: 'Спецификации',
      dimensions: 'Размеры',
      material: 'Материал',
      weight: 'Вес',
      finish: 'Отделка',
      warranty: '24 месяца гарантии',
      assembly: 'Требуется сборка',
      delivery: 'Бесплатная доставка',
      returns: 'Бесплатный возврат',
      buyNow: 'Купить сейчас',
      notFound: 'Товар не найден',
      returnToCollection: 'Вернуться к коллекции',
    },
  },
};